<template>
  <section>
    <nav class="columns">
      <div class="column">
        <b-field grouped group-multiline>
          <b-field>
            <p class="control">
              <span class="button is-static">
                {{ $t('attributes.activation_status') }}
              </span>
            </p>
            <b-select v-model="filterStatus" @input="loadTravelGroups">
              <option value="">{{ $t('attributes.all') }}</option>
              <option value="true">{{ $t('attributes.shelve_on') }}</option>
              <option value="false">{{ $t('attributes.shelve_off') }}</option>
            </b-select>
          </b-field>
          <b-field>
            <b-autocomplete
              v-model="collaborate_name"
              name="collaborate"
              field="name"
              :data="filteredCollaborates"
              :loading="loadingCollaborates"
              :placeholder="
                $t('attributes.collaborate') + $t('attributes.name')
              "
              :open-on-focus="true"
              @typing="filteringCollaborates"
              @select="onSelectCollaborate"
            >
              <template #empty>
                No results found
              </template>
            </b-autocomplete>
          </b-field>
          <b-field class="activity-selector">
            <b-autocomplete
              v-model="activities_name"
              name="attributes.collaborate"
              field="name"
              :data="filteredActivities"
              :loading="loadingActivities"
              :placeholder="
                $t('attributes.collaborate_activity') + $t('attributes.name')
              "
              :open-on-focus="true"
              @typing="filteringActivities"
              @select="onSelectActivity"
            >
              <template #empty>
                {{
                  !selectedCollaborateId ? '請先選擇企業' : '此企業尚未建立活動'
                }}
              </template>
            </b-autocomplete>
          </b-field>
          <b-field>
            <b-input
              v-model="search_code"
              :placeholder="$t('attributes.collaborate_group_code')"
              type="search"
              icon="magnify"
              @input="onFilter"
            ></b-input>
          </b-field>
          <b-field>
            <b-input
              v-model="search_name"
              :placeholder="
                $t('attributes.collaborate_group') + $t('attributes.name')
              "
              type="search"
              icon="magnify"
              @input="onFilter"
            ></b-input>
          </b-field>
        </b-field>
      </div>

      <div class="column is-3">
        <div class="buttons is-right">
          <b-button
            :loading="sending"
            class="is-primary"
            icon-left="content-copy"
            @click="isCloneModalActive = true"
          >
            {{ $t('attributes.copy') + $t('attributes.collaborate_group') }}
          </b-button>
          <b-button
            :loading="sending"
            class="is-primary"
            icon-left="plus"
            @click="isCreateModalActive = true"
          >
            {{ $t('attributes.add') + $t('attributes.collaborate_group') }}
          </b-button>
        </div>
      </div>
    </nav>

    <b-table
      :data="items"
      :selected.sync="selectedItem"
      :loading="isLoading"
      :hoverable="true"
      :narrowed="true"
      :mobile-cards="true"
      :row-class="rowClass"
      paginated
      backend-pagination
      backend-sorting
      :total="total"
      :per-page="perPage"
      :default-sort-direction="defaultSortOrder"
      :default-sort="[sortField, sortOrder]"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      @page-change="onPageChange"
      @sort="onSort"
    >
      <b-table-column
        field="code"
        :label="$t('attributes.collaborate_group_code')"
        width="160"
        sortable
        v-slot="props"
      >
        {{ props.row.code }}
      </b-table-column>

      <b-table-column
        field="shelve_on"
        :label="$t('attributes.activation_status')"
        width="90"
        sortable
        v-slot="props"
      >
        <b-tag
          :type="
            props.row.is_deprecated
              ? 'is-warning'
              : props.row.shelve_on
              ? 'is-info'
              : 'is-danger'
          "
          size="is-medium"
        >
          {{ groupShelveStatus(props.row) }}
        </b-tag>
      </b-table-column>

      <b-table-column
        field="days"
        :label="$t('attributes.days')"
        width="85"
        sortable
        v-slot="props"
      >
        {{ props.row.days }}
      </b-table-column>

      <b-table-column
        field="departure_date"
        :label="$t('attributes.departure_date')"
        width="150"
        sortable
        v-slot="props"
      >
        {{ formatDate(props.row.departure_date) }}
      </b-table-column>

      <b-table-column
        field="registration_start_date"
        :label="$t('attributes.registration_range')"
        width="300"
        sortable
        v-slot="props"
      >
        {{ formatDate(props.row.registration_start_date) }} -
        {{ formatDate(props.row.registration_end_date) }}
      </b-table-column>

      <b-table-column
        field="signup_deadline"
        :label="$t('attributes.signup_deadline')"
        width="150"
        sortable
        v-slot="props"
      >
        {{ formatDate(props.row.signup_deadline) }}
      </b-table-column>

      <b-table-column
        field="name"
        :label="$t('attributes.collaborate_group') + $t('attributes.name')"
        width="300"
        sortable
        v-slot="props"
      >
        <!-- eslint-disable-next-line-->
        <p v-html="props.row.name"></p>
      </b-table-column>

      <b-table-column
        field="sign_up_quantity"
        :label="$t('attributes.max_quantity')"
        width="125"
        numeric
        sortable
        v-slot="props"
      >
        {{ props.row.quantity }}
      </b-table-column>

      <b-table-column
        field="is_full"
        :label="$t('attributes.fulled')"
        width="95"
        sortable
        v-slot="props"
      >
        <b-tag
          :type="props.row.is_full ? 'is-danger' : 'is-info'"
          size="is-medium"
        >
          {{ translate_full(props.row.is_full) }}
        </b-tag>
      </b-table-column>

      <b-table-column
        field="is_expired"
        :label="$t('attributes.expired')"
        width="95"
        sortable
        v-slot="props"
      >
        <b-tag
          :type="props.row.is_expired ? 'is-danger' : 'is-info'"
          size="is-medium"
        >
          {{ translate_expired(props.row.is_expired) }}
        </b-tag>
      </b-table-column>

      <template #empty>
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large" />
            </p>
            <p v-if="selectedActivityId">{{ $t('attributes.empty') }}</p>
            <p v-else-if="selectedCollaborateId">請選擇活動</p>
            <p v-else>請先選擇企業</p>
          </div>
        </section>
      </template>
    </b-table>

    <hr />

    <section style="min-height: 400px;">
      <edit-form
        v-if="selectedItem"
        :code="selectedItem.code"
        :loading.sync="loadingGroup"
        :type="GROUP_TYPE.FIRM"
        @updated="onUpdated"
        @deleted="onDeleted"
        @deprecated="onDeprecated"
      />
    </section>

    <b-modal
      :active.sync="isCloneModalActive"
      :can-cancel="['escape', 'x']"
      scroll="keep"
      has-modal-card
    >
      <clone-form :is-sending="sending" @onSend="onClone" />
    </b-modal>

    <b-modal
      :active.sync="isCreateModalActive"
      :can-cancel="['escape', 'x']"
      scroll="keep"
      has-modal-card
    >
      <create-form :is-sending="sending" @onSend="onCreate" />
    </b-modal>
  </section>
</template>

<script>
import debounce from 'lodash/debounce'
import {
  TRAVEL_GROUPS_API,
  FIRM_COLLABORATES_API,
  FIRM_COLLABORATES_ACTIVITIES_API
} from '@/utils/apis'
import CreateForm from '@/components/firm/TravelGroupCreateForm'
import CloneForm from '@/components/firm/TravelGroupCloneForm'
import EditForm from '@/components/travel_groups/Form'
import notifyService from '@/services/notifyService'

export default {
  name: 'CollaborateTravelGroups',
  components: {
    CreateForm,
    CloneForm,
    EditForm
  },

  data() {
    return {
      loadingGroups: false,
      total: 0,
      items: [],
      selectedItem: null,
      loadingGroup: false,

      filterStatus: '',
      search_code: '',
      search_name: '',
      sortField: 'code',
      sortOrder: 'asc',
      defaultSortOrder: 'asc',
      page: 1,
      perPage: 10,

      isCloneModalActive: false,
      isCreateModalActive: false,
      sending: false,

      loadingCollaborates: false,
      collaborate_name: '',
      collaborates: [],
      filteredCollaborates: [],
      selectedCollaborateId: null,

      loadingActivities: false,
      activities_name: '',
      activities: [],
      filteredActivities: [],
      selectedActivityId: null
    }
  },
  computed: {
    isLoading() {
      return (
        this.loadingCollaborates ||
        this.loadingActivities ||
        this.loadingGroups ||
        this.loadingGroup
      )
    }
  },
  mounted() {
    this.loadCollaborates()
  },
  methods: {
    async loadTravelGroups() {
      const api = TRAVEL_GROUPS_API

      const params = {
        is_collaborate: true,
        collaborate_id: this.selectedCollaborateId,
        activity_id: this.selectedActivityId,
        active: this.filterStatus && this.filterStatus === 'true',
        search_code: this.search_code,
        search: this.search_name,
        show_expired: true,
        sort_by: this.sortField,
        by_descending: this.sortOrder !== 'asc',
        page_size: this.perPage,
        page_number: this.page
      }

      this.loadingGroups = true
      try {
        const res = await this.axios.get(api, { params })
        const data = res.data.data

        this.items = data.items
        this.total = data.item_count
      } catch (e) {
        this.items = []
        this.total = 0

        notifyService.fetch_error('collaborate_group', e)
      } finally {
        this.loadingGroups = false
      }
    },
    async loadCollaborates() {
      const api = `${FIRM_COLLABORATES_API}/list`

      this.loadingCollaborates = true
      try {
        const res = await this.axios.get(api)
        this.collaborates = res.data.data
        this.filteringCollaborates()

        await this.loadTravelGroups()
      } catch (e) {
        this.collaborates = []
        this.filteredCollaborates = []
        this.selectedCollaborateId = null

        notifyService.fetch_error('collaborate', e)
      } finally {
        this.loadingCollaborates = false
      }
    },
    async loadActivities() {
      const api = `${FIRM_COLLABORATES_ACTIVITIES_API}/list`
      const params = {
        collaborate_id: this.selectedCollaborateId
      }

      this.loadingActivities = true
      try {
        const res = await this.axios.get(api, { params })

        this.activities = res.data.data
        this.activities_name = ''
        this.filteringActivities()
      } catch (e) {
        this.activities = []
        this.filteredActivities = []
        this.selectedActivityId = null

        notifyService.fetch_error('collaborate_activity', e)
      } finally {
        this.loadingActivities = false
      }
    },

    filteringCollaborates: debounce(function() {
      this.filteredCollaborates = this.collaborates.filter(option => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.collaborate_name.toLowerCase()) >= 0
        )
      })
    }, 500),
    onSelectCollaborate(option) {
      const id = option && option.id

      if (this.selectedCollaborateId === id) {
        return
      }

      this.selectedCollaborateId = id
      this.activities_name = ''
      this.activities = []
      this.filteredActivities = []
      this.selectedActivityId = null
      this.loadActivities()
    },

    filteringActivities: debounce(function() {
      this.filteredActivities = this.activities.filter(option => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.activities_name.toLowerCase()) >= 0
        )
      })
    }, 500),
    onSelectActivity(option) {
      const id = option && option.id

      if (this.selectedActivityId === id) {
        return
      }

      this.selectedActivityId = id
      this.loadTravelGroups()
    },

    onFilter: debounce(function() {
      this.loadTravelGroups()
    }, 500),
    onPageChange(page) {
      this.page = page
      this.loadTravelGroups()
    },
    onSort(field, order) {
      this.sortField = field
      this.sortOrder = order
      this.loadTravelGroups()
    },

    async onCreate(item) {
      const api = `${TRAVEL_GROUPS_API}`

      this.sending = true
      try {
        await this.axios.post(api, item)

        this.isCreateModalActive = false

        notifyService.success(this.$t('attributes.add_succeed'))
        await this.loadTravelGroups()
      } catch (e) {
        notifyService.create_error(e)
      } finally {
        this.sending = false
      }
    },

    async onClone(code, item) {
      const api = `${TRAVEL_GROUPS_API}/${code}/clone`

      this.sending = true
      try {
        await this.axios.post(api, item)
        this.isCloneModalActive = false

        notifyService.success(this.$t('attributes.add_succeed'))
        await this.loadTravelGroups()
      } catch (e) {
        notifyService.create_error(e)
      } finally {
        this.sending = false
      }
    },
    onUpdated(group) {
      this.items = this.items.map(g => {
        if (g.code === group.code) {
          return group
        } else {
          return g
        }
      })
      this.selectedItem = group
    },
    onDeprecated(group) {
      this.items = this.items.map(g => {
        if (g.code === group.code) {
          return group
        } else {
          return g
        }
      })
      this.selectedItem = group
    },
    onDeleted(code) {
      this.items = this.items.filter(i => i.code !== code)
      this.selectedItem = null
    },

    rowClass(item) {
      return {
        'taken-off': item.shelve_on,
        expired: item.is_expired,
        fulled: item.is_full
      }
    },
    translate_full(is_full) {
      return this.$t(is_full ? 'attributes.fulled' : 'attributes.not_fulled')
    },
    translate_expired(is_expired) {
      return this.$t(
        is_expired ? 'attributes.has_expired' : 'attributes.not_expired'
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.b-table {
  margin-top: 0.75rem;
}

.activity-selector {
  width: 200px;
}

.datepicker {
  .datepicker-table {
    .datepicker-cell {
      padding: 0.6rem 0.65rem;
    }
  }
}
</style>
